// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"7dcade44","787":"2bf7b87f"}[chunkId] + ".chunk.js";
};